const CHILDVIEW_PREFIX = 'childview_'

// childview_Depth/123 -> { baseName: 'Depth', id: 123 }; null for the main view,
// non-popout names, or names without a numeric id.
export const parseChildviewName = (
  name: unknown
): { baseName: string; id: number } | null => {
  if (typeof name !== 'string' || !name.startsWith(CHILDVIEW_PREFIX)) {
    return null
  }
  const match = name.slice(CHILDVIEW_PREFIX.length).match(/^([^/]+)\/(\d+)$/)
  if (!match) return null
  return { baseName: match[1], id: Number(match[2]) }
}
